import { render, staticRenderFns } from "./warehouse-patch-new.vue?vue&type=template&id=9a5f90b6&scoped=true&"
import script from "./warehouse-patch-new.vue?vue&type=script&lang=ts&"
export * from "./warehouse-patch-new.vue?vue&type=script&lang=ts&"
import style0 from "./warehouse-patch-new.vue?vue&type=style&index=0&id=9a5f90b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a5f90b6",
  null
  
)

export default component.exports